<template>
    <div class="py-3 row" v-if="eligibility?.hospice.success == 'Yes'">
        <h6 class="col-12"><i class="fas fa-calendar-alt text-app-primary"></i> Hospice Benefit Periods</h6>
        <div class="col-12 mt-2">
            <table class="table table-responsive-md border mb-0">
                <thead>
                    <tr class="bg-table-header">
                        <th class="text-start">Dates</th>
                        <th class="text-center">Days Spent</th>
                        <th class="text-start">Payer</th>
                        <th class="text-start">Name</th>
                        <th class="text-start">Reference ID Qualifier</th>
                        <th class="text-start">Reference ID</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="period of eligibility.hospice.periods">
                        <td class="text-start">
                            <span v-if="period.period_date_range">
                                <span>{{ formatDate(period.period_date_range.split("-")[0]) }}</span>
                                -
                                <span>{{ formatDate(period.period_date_range.split("-")[1]) }}</span>
                            </span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-center">
                            <span v-if="period.daysSpent">{{ period.daysSpent }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-start">
                            <span v-if="period.payer">{{ period.payer }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-start">
                            <span v-if="period.name">{{ period.name }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-start">
                            <span v-if="period.reference_id_qualifier">{{ period.reference_id_qualifier }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                        <td class="text-start">
                            <span v-if="period.reference_id">{{ period.reference_id }}</span>
                            <i class="text-default" v-else>Not Available</i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { formatDate } from "../../../../common/vue-helpers/modifiers/value-modifier";

export default defineComponent({
    props: {
        eligibility: {
            type: Object
        }
    },

    data() {
        return {
            formatDate
        };
    }
});
</script>
